<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                <v-icon class="me-2">mdi-filter</v-icon>
                                Search Form
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">
                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                                label="Search Product Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.name}`"
                                                item-value="product_id"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col md="3" cols="12">
                                            <v-date-input
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>
                                        <v-col md="3" cols="12">
                                            <v-date-input
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>
                                        <v-col lg="2" md="2" cols="12">
                                            <v-btn
                                                class="bg-brand w-15"
                                                type="submit"
                                                ref="searchButton"
                                            >Search</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid style="margin-top: -20px;">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                <v-icon class="me-2">mdi-file-document-edit-outline</v-icon>
                                Purchase Order Report
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="6">
                                        <v-text-field
                                            v-model="search"
                                            append-inner-icon="mdi-magnify"
                                            label="Search"
                                            single-line
                                            hide-details
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            class="pl-2"
                                            clearable
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="4" cols="6">
                                        <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                        >
                                            <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                :disabled="getSchema.length === 0"
                                            >CSV</v-btn>

                                            <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                :disabled="getSchema.length === 0"
                                            >EXCEL</v-btn>

                                            <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                :disabled="getSchema.length === 0"
                                            >PDF</v-btn>
                                        </v-btn-group>
                                    </v-col>
                                </v-row>

                                <div v-if="!getSchema.length && !loading" class="py-6 text-center text-medium-emphasis">
                                    <v-icon size="64" color="grey-lighten-1" class="mb-2">mdi-file-remove</v-icon>
                                    <div class="text-h6 text-grey mt-4">No Purchase Order Data Found</div>
                                    <div class="text-body-2 text-grey">Try adjusting filters or search criteria</div>
                                </div>

                                <v-data-table
                                    v-else
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"
                                    density="compact"
                                >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>
                                    <template v-slot:item.purOrderMaster.code="{ item }">
                                        <v-chip size="small" color="primary" variant="outlined">
                                            {{ item.pur_order_master?.code || item.purOrderMaster?.code || 'N/A' }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item.purchase_date="{ item }">
                                        {{ formatDateDash(item.purchase_date) }}
                                    </template>
                                    <template v-slot:item.purOrderMaster.branch.name="{ item }">
                                        {{ item.pur_order_master?.branch?.name || item.purOrderMaster?.branch?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.purOrderMaster.branch.company.name="{ item }">
                                        {{ item.pur_order_master?.branch?.company?.name || item.purOrderMaster?.branch?.company?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.purOrderMaster.supplier.supplier_name="{ item }">
                                        {{ item.pur_order_master?.supplier?.supplier_name || item.purOrderMaster?.supplier?.supplier_name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.product.name="{ item }">
                                        {{ item.product?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.product.code="{ item }">
                                        {{ item.product?.code || 'N/A' }}
                                    </template>
                                    <template v-slot:item.product.unit.name="{ item }">
                                        {{ item.product?.unit?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.product.secondaryUnit.name="{ item }">
                                        {{ item.product?.secondary_unit?.name || item.product?.secondaryUnit?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.purOrderMaster.created_by.full_name="{ item }">
                                        {{ item.pur_order_master?.created_by?.full_name || item.purOrderMaster?.created_by?.full_name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.purOrderMaster.approvalProcess.approvedBy.full_name="{ item }">
                                        {{ getApprovedByNames(item) }}
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { formatDateDash } from "@/plugins/dateFormatView";
import formattedDate from "@/plugins/dateFormatter";

export default {
    data: () => ({
        itemsPerPage: -1,
        panel: [0],
        panel2: [0],
        search: "",
        headers: [
            { title: "#SL", key: "index", align: "center", width: "5%", sortable: false },
            { title: "PO Code", key: "purOrderMaster.code", align: "left", sortable: false, width: "120px" },
            { title: "Purchase Date", key: "purchase_date", align: "left", sortable: true, width: "140px" },
            { title: "Branch", key: "purOrderMaster.branch.name", align: "left", sortable: false, width: "140px" },
            { title: "Company", key: "purOrderMaster.branch.company.name", align: "left", sortable: false, width: "160px" },
            { title: "Supplier", key: "purOrderMaster.supplier.supplier_name", align: "left", sortable: false, width: "180px" },
            { title: "Product Code", key: "product.code", align: "left", sortable: false, width: "120px" },
            { title: "Product Name", key: "product.name", align: "left", sortable: false, width: "200px" },
            { title: "Quantity", key: "qty", align: "right", sortable: false, width: "110px" },
            { title: "Unit", key: "product.unit.name", align: "left", sortable: false, width: "110px" },
            { title: "Secondary Unit", key: "product.secondaryUnit.name", align: "left", sortable: false, width: "140px" },
            { title: "Rate", key: "rate", align: "right", sortable: false, width: "110px" },
            { title: "Amount", key: "amount", align: "right", sortable: false, width: "120px" },
            { title: "Created By", key: "purOrderMaster.created_by.full_name", align: "left", sortable: false, width: "150px" },
            { title: "Approved By", key: "purOrderMaster.approvalProcess.approvedBy.full_name", align: "left", sortable: false, width: "200px" },
        ],
    }),
    created() {
        if (this.$store.getters.getProductMapList.length === 0) {
            this.loading = true;
            this.$store.dispatch("getProductMapList").finally(() => {
                this.loading = false;
            });
        }
    },
    computed: {
        getSchema() {
            return this.$store.getters.getPurPOOrderReport;
        },
        getProductMapList() {
            const data = this.$store.getters.getProductMapList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
    },
    setup() {
        const { handleSubmit } = useForm({
            validationSchema: yup.object({}),
        });

        const product_id = useField("product_id");
        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const loading = ref(false);
        const store = useStore();

        const submit = handleSubmit(() => {
            loading.value = true;
            const params = {};
            if (product_id.value.value) {
                params.product_id = product_id.value.value;
            }
            if (from_date.value.value) {
                params.from_date = formattedDate(from_date.value.value);
            }
            if (to_date.value.value) {
                params.to_date = formattedDate(to_date.value.value);
            }
            store
                .dispatch("getPurPOOrderReport", params)
                .then((response) => {
                    loading.value = false;
                    if (response.data.success) {
                        toast.success(response.data.message || "Data loaded successfully");
                    }
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error?.response?.data?.message || "An error occurred");
                });
        });

        return {
            product_id,
            from_date,
            to_date,
            submit,
            loading,
        };
    },
    methods: {
        formatDateDash,
        formattedDate,
        getApprovedByNames(item) {
            const master = item.pur_order_master || item.purOrderMaster;
            if (!master) return "N/A";

            const approvalProcess = master.approval_process || master.approvalProcess;
            if (!approvalProcess) return "N/A";

            const processes = Array.isArray(approvalProcess) ? approvalProcess : [approvalProcess];
            const names = processes
                .map((process) => {
                    const approvedBy = process.approved_by || process.approvedBy;
                    return approvedBy?.full_name || null;
                })
                .filter(Boolean);

            return names.length > 0 ? names.join(", ") : "N/A";
        },
        exportToCSV() {
            if (!this.getSchema || this.getSchema.length === 0) {
                toast.warning("No data to export");
                return;
            }

            const columns = [
                "#SL",
                "PO Code",
                "Purchase Date",
                "Branch",
                "Company",
                "Supplier",
                "Product Code",
                "Product Name",
                "Quantity",
                "Unit",
                "Secondary Unit",
                "Rate",
                "Amount",
                "Created By",
                "Approved By",
            ];

            let serialNum = 1;
            const rows = this.getSchema.map((item) => [
                serialNum++,
                item.pur_order_master?.code || item.purOrderMaster?.code || "",
                formatDateDash(item.purchase_date),
                item.pur_order_master?.branch?.name || item.purOrderMaster?.branch?.name || "",
                item.pur_order_master?.branch?.company?.name || item.purOrderMaster?.branch?.company?.name || "",
                item.pur_order_master?.supplier?.supplier_name || item.purOrderMaster?.supplier?.supplier_name || "",
                item.product?.code || "",
                item.product?.name || "",
                item.qty ?? 0,
                item.product?.unit?.name || "",
                item.product?.secondary_unit?.name || item.product?.secondaryUnit?.name || "",
                item.rate ?? 0,
                item.amount ?? 0,
                item.pur_order_master?.created_by?.full_name || item.purOrderMaster?.created_by?.full_name || "",
                this.getApprovedByNames(item),
            ]);

            const data = [columns, ...rows];
            const proxy = this.$appContext?.config?.globalProperties;
            if (proxy?.$exportTableToCSV && proxy?.$fileDate) {
                proxy.$exportTableToCSV(data, "purchase_order_report_" + proxy.$fileDate());
            } else if (this.$exportTableToCSV && this.$fileDate) {
                this.$exportTableToCSV(data, "purchase_order_report_" + this.$fileDate());
            }
        },
        exportToExcel() {
            if (!this.getSchema || this.getSchema.length === 0) {
                toast.warning("No data to export");
                return;
            }

            const data = [[
                "#SL",
                "PO Code",
                "Purchase Date",
                "Branch",
                "Company",
                "Supplier",
                "Product Code",
                "Product Name",
                "Quantity",
                "Unit",
                "Secondary Unit",
                "Rate",
                "Amount",
                "Created By",
                "Approved By",
            ]];

            let serialNum = 1;
            this.getSchema.forEach((item) => {
                data.push([
                    serialNum++,
                    item.pur_order_master?.code || item.purOrderMaster?.code || "",
                    formatDateDash(item.purchase_date),
                    item.pur_order_master?.branch?.name || item.purOrderMaster?.branch?.name || "",
                    item.pur_order_master?.branch?.company?.name || item.purOrderMaster?.branch?.company?.name || "",
                    item.pur_order_master?.supplier?.supplier_name || item.purOrderMaster?.supplier?.supplier_name || "",
                    item.product?.code || "",
                    item.product?.name || "",
                    item.qty ?? 0,
                    item.product?.unit?.name || "",
                    item.product?.secondary_unit?.name || item.product?.secondaryUnit?.name || "",
                    item.rate ?? 0,
                    item.amount ?? 0,
                    item.pur_order_master?.created_by?.full_name || item.purOrderMaster?.created_by?.full_name || "",
                    this.getApprovedByNames(item),
                ]);
            });

            const proxy = this.$appContext?.config?.globalProperties;
            if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
                proxy.$exportTableToExcel(data, "purchase_order_report_" + proxy.$fileDate());
            } else if (this.$exportTableToExcel && this.$fileDate) {
                this.$exportTableToExcel(data, "purchase_order_report_" + this.$fileDate());
            }
        },
        exportToPDF() {
            if (!this.getSchema || this.getSchema.length === 0) {
                toast.warning("No data to export");
                return;
            }

            const columns = [
                "#SL",
                "PO Code",
                "Purchase Date",
                "Branch",
                "Company",
                "Supplier",
                "Product Code",
                "Product Name",
                "Quantity",
                "Unit",
                "Secondary Unit",
                "Rate",
                "Amount",
                "Created By",
                "Approved By",
            ];

            let serialNum = 1;
            const rows = this.getSchema.map((item) => [
                serialNum++,
                item.pur_order_master?.code || item.purOrderMaster?.code || "",
                formatDateDash(item.purchase_date),
                item.pur_order_master?.branch?.name || item.purOrderMaster?.branch?.name || "",
                item.pur_order_master?.branch?.company?.name || item.purOrderMaster?.branch?.company?.name || "",
                item.pur_order_master?.supplier?.supplier_name || item.purOrderMaster?.supplier?.supplier_name || "",
                item.product?.code || "",
                item.product?.name || "",
                item.qty ?? 0,
                item.product?.unit?.name || "",
                item.product?.secondary_unit?.name || item.product?.secondaryUnit?.name || "",
                item.rate ?? 0,
                item.amount ?? 0,
                item.pur_order_master?.created_by?.full_name || item.purOrderMaster?.created_by?.full_name || "",
                this.getApprovedByNames(item),
            ]);

            const proxy = this.$appContext?.config?.globalProperties;
            if (proxy?.$exportTableToPDF && proxy?.$fileDate) {
                proxy.$exportTableToPDF(columns, rows, "Purchase Order Report", "purchase_order_report_" + proxy.$fileDate());
            } else if (this.$exportTableToPDF && this.$fileDate) {
                this.$exportTableToPDF(columns, rows, "Purchase Order Report", "purchase_order_report_" + this.$fileDate());
            }
        },
    },
};
</script>

<style scoped>
.panel-header {
    font-weight: 600;
}
</style>

